export const Prices = [
  {
    _id: 0,
    name: "₹0 to ₹10000",
    array: [0, 10000],
  },
  {
    _id: 1,
    name: "₹10000 to ₹30000",
    array: [10000, 30000],
  },
  {
    _id: 2,
    name: "₹30000 to ₹70000",
    array: [30000, 70000],
  },
  {
    _id: 4,
    name: "₹70000 to ₹150000",
    array: [70000, 150000],
  },
];
